var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2531 17.9039H5.95417C3.16448 17.9039 1.30469 16.5091 1.30469 13.2545V6.74519C1.30469 3.49055 3.16448 2.0957 5.95417 2.0957H15.2531C18.0428 2.0957 19.9026 3.49055 19.9026 6.74519V13.2545C19.9026 16.5091 18.0428 17.9039 15.2531 17.9039Z",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6022 12.7893C12.1429 12.7893 13.3919 11.5404 13.3919 9.99965C13.3919 8.45895 12.1429 7.20996 10.6022 7.20996C9.06149 7.20996 7.8125 8.45895 7.8125 9.99965C7.8125 11.5404 9.06149 12.7893 10.6022 12.7893Z",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30469 7.21003H2.23458C5.02427 7.21003 5.95417 6.28013 5.95417 3.49044V2.56055",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8995 7.21003H18.9696C16.1799 7.21003 15.25 6.28013 15.25 3.49044V2.56055",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30469 12.79H2.23458C5.02427 12.79 5.95417 13.7199 5.95417 16.5096V17.4395",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8995 12.79H18.9696C16.1799 12.79 15.25 13.7199 15.25 16.5096V17.4395",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotsIcon);
export default __webpack_public_path__ + "static/media/potsIcon.9d46f68896bbc07794da62a2d419cdc3.svg";
export { ForwardRef as ReactComponent };